import { defineComponent as _defineComponent } from 'vue'
import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Thông tin thí sinh", -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Nơi học THPT", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", null, " (ghi tên trường và nơi trường đóng: huyện (quận), tỉnh (thành phố) và ghi mã tỉnh, mã trường) ")
], -1)

import { onMounted, ref, watch } from "vue";
import Divider from "primevue/divider";
import InputTextWithLabel from "../commons/InputTextWithLabel.vue";
import DropdownWithLabel from "../commons/DropdownWithLabel.vue";
import CalanderWithLabel from "../commons/CalanderWithLabel.vue";

import { OptionItem, Options } from '@/models/Options.model';
import {
  Genders
} from "../categories";

export default /*#__PURE__*/_defineComponent({
  __name: 'ThongTinChung',
  props: {
    isViewMode: { type: Boolean },
    modelValue: {},
    options: {},
    token: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const districtOptions = ref<OptionItem[]>([]);
const info = ref(props.modelValue);
watch(info, val => {
  emit('update:modelValue', val);
}, {
  immediate: true,
  deep: true
})
onMounted(() => {
  if (info.value.provinceCode)
    districtOptions.value = props.options.districts.filter(x => x.metadata == info.value.provinceCode);
})
watch(() => info.value.provinceCode, province => {
  if (province) {
    districtOptions.value = props.options.districts.filter(x => x.metadata == province);
    info.value.districtCode = null;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isViewMode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Divider), {
              align: "center",
              type: "solid"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.fullName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((info.value.fullName) = $event)),
            name: "fullName",
            class: "col-12 sm:col-6 md:col-9 flex flex-column gap-2",
            label: "Họ, chữ đệm và tên của thí sinh*",
            "small-label": "(viết đúng như trong giấy khai sinh bằng chữ in hoa có dấu)"
          }, null, 8, ["modelValue"]),
          _createVNode(DropdownWithLabel, {
            modelValue: info.value.gender,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((info.value.gender) = $event)),
            options: _unref(Genders),
            name: "gender",
            "option-value": "value",
            label: "Giới tính*",
            class: "col-12 sm:col-6 md:col-3 flex flex-column gap-2"
          }, null, 8, ["modelValue", "options"]),
          _createVNode(CalanderWithLabel, {
            label: "Ngày/tháng/năm sinh*",
            name: "birthday",
            modelValue: info.value.birthday,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((info.value.birthday) = $event)),
            class: "col-12 sm:col-4 flex flex-column gap-2"
          }, null, 8, ["modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.placeOfBirth,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((info.value.placeOfBirth) = $event)),
            name: "placeOfBirth",
            class: "col-12 sm:col-8 flex flex-column gap-2",
            label: "Nơi sinh*",
            "small-label": "(tỉnh hoặc thành phố)"
          }, null, 8, ["modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.nation,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((info.value.nation) = $event)),
            name: "nation",
            class: "col-12 sm:col-4 flex flex-column gap-2",
            label: "Dân tộc",
            "small-label": "(ghi bằng chữ)"
          }, null, 8, ["modelValue"]),
          _createVNode(DropdownWithLabel, {
            options: _ctx.options.priorityAreas,
            "option-label": "text",
            "option-value": "value",
            modelValue: info.value.priorityAreaId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((info.value.priorityAreaId) = $event)),
            name: "priorityAreaId",
            class: "col-12 sm:col-6 md:col-4 flex flex-column gap-2",
            label: "Khu vực ưu tiên*",
            placeholder: "Chọn khu vực ưu tiên"
          }, null, 8, ["options", "modelValue"]),
          _createVNode(DropdownWithLabel, {
            options: _ctx.options.priorityObjects,
            "option-label": "text",
            "option-value": "value",
            "show-clear": "",
            modelValue: info.value.priorityObjectId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((info.value.priorityObjectId) = $event)),
            name: "priorityObjectId",
            class: "col-12 sm:col-6 md:col-4 flex flex-column gap-2",
            label: "Đối tượng ưu tiên (nếu có)",
            placeholder: "Đối tượng ưu tiên"
          }, null, 8, ["options", "modelValue"]),
          _createVNode(InputTextWithLabel, {
            disabled: _ctx.token,
            modelValue: info.value.identityNumber,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((info.value.identityNumber) = $event)),
            name: "identityNumber",
            class: "col-12 sm:col-4 flex flex-column gap-2",
            label: "Căn cước công dân*"
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(CalanderWithLabel, {
            label: "Ngày cấp*",
            name: "dateGranted",
            modelValue: info.value.dateGranted,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((info.value.dateGranted) = $event)),
            class: "col-12 sm:col-4 flex flex-column gap-2"
          }, null, 8, ["modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.placeOfGranted,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((info.value.placeOfGranted) = $event)),
            name: "placeOfGranted",
            class: "col-12 sm:col-4 flex flex-column gap-2",
            label: "Nơi cấp*"
          }, null, 8, ["modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.permanentAddress,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((info.value.permanentAddress) = $event)),
            name: "permanentAddress",
            class: "col-12 flex flex-column gap-2",
            label: "Hộ khẩu thường trú*"
          }, null, 8, ["modelValue"]),
          _createVNode(DropdownWithLabel, {
            options: _ctx.options.provinces,
            "option-label": "text",
            "option-value": "value",
            modelValue: info.value.provinceCode,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((info.value.provinceCode) = $event)),
            name: "provinceCode",
            class: "col-12 sm:col-6 flex flex-column gap-2",
            label: "Tỉnh (Tp)*",
            placeholder: "Chọn tỉnh (Tp)"
          }, null, 8, ["options", "modelValue"]),
          _createVNode(DropdownWithLabel, {
            options: districtOptions.value,
            "option-label": "text",
            "option-value": "value",
            modelValue: info.value.districtCode,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((info.value.districtCode) = $event)),
            name: "districtCode",
            class: "col-12 sm:col-6 flex flex-column gap-2",
            label: "Phường / Xã*",
            placeholder: "Chọn phường / xã"
          }, null, 8, ["options", "modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.mobile,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((info.value.mobile) = $event)),
            name: "mobile",
            class: "col-12 sm:col-6 flex flex-column gap-2",
            label: "Điện thoại liên lạc*"
          }, null, 8, ["modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.email,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((info.value.email) = $event)),
            name: "email",
            class: "col-12 sm:col-6 flex flex-column gap-2",
            label: "Email*"
          }, null, 8, ["modelValue"]),
          _createVNode(InputTextWithLabel, {
            modelValue: info.value.address,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((info.value.address) = $event)),
            name: "address",
            class: "col-12 flex flex-column gap-2",
            label: "Địa chỉ liên hệ*"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Divider), {
              align: "center",
              type: "solid"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ])
        ], 64))
  ]))
}
}

})